module.exports = __webpack_public_path__ + "img/2x.1a31c02.jpg";